import styled from 'styled-components';

import { Label as XdlLabel } from '@xing-com/label';

// *** Components ***
export const Label = styled(XdlLabel)`
  line-height: 1.8;
  width: 100%;
`;
